export default <R = void>(func: () => Promise<R>) => {
  let promise: Promise<R> | null = null;
  return async () => {
    if (promise) return promise;
    try {
      promise = func();
      const result = await promise;
      return result as R;
    } finally {
      promise = null;
    }
  };
};
